export const invoicePayload = {
  invoices: [],
  totalElements: 0,
};

export const populateInvoicePayload = (payload, response) => {
  payload.invoices =
    response.data.totalElements > 0
      ? [...payload.invoices, ...response.data.invoices]
      : [];
  payload.totalElements = response.data.totalElements;
  payload.totalPages = response.data.totalPages;

  return payload;
};
